import { render, staticRenderFns } from "./EmailDetailModel.vue?vue&type=template&id=3305ca42&"
import script from "./EmailDetailModel.vue?vue&type=script&lang=js&"
export * from "./EmailDetailModel.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetailModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports